<template>
  <span :class="'badge tag-badge tag-' + tag.type_name">
    <span class="name" v-html="name"></span>

    <button type="button" class="btn" @click="removeTag">
      <span class="fa-stack fa-2x">
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fal fa-times fa-stack-1x fa-inverse"></i>
      </span>
    </button>
  </span>
</template>

<script>
export default {
  name: "TagBadge",
  props: {
    tag: Object,
  },
  methods: {
    removeTag() {
      if (this.tag.type == "post_type") {
        this.$store.commit("REMOVE_POSTTYPE", this.tag.term_id);
      } else if (this.tag.type == "tag") {
        this.$store.commit("REMOVE_TAG", this.tag.term_id);
      } else {
        this.$store.commit("REMOVE_TAXONOMY", [
          this.tag.type_name,
          this.tag.term_id,
        ]);
      }

      this.$store.dispatch("newRequest");
    },
  },
  computed: {
    name: function () {
      if (this.tag.type_name == "tag") {
        return "#" + this.tag.name;
      }

      return this.tag.name;
    },
  },
};
</script>
